import React, { useState, useEffect } from "react";
import VuiTypography from "components/ui/VuiTypography";
import { styled } from "@mui/material/styles";
import { GRADIENTS } from "utils/designTokens";

const Cursor = styled("span")({
  display: "inline-block",
  width: "2px",
  height: "1em",
  background: GRADIENTS.accent,
  borderRadius: "1px",
  marginLeft: "2px",
  verticalAlign: "text-bottom",
  animation: "blink 1s step-end infinite",
  "@keyframes blink": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0 },
  },
});

const TypingText = ({ text, speed = 30, sx, color = "inherit" }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  // Effect to handle the typing animation
  useEffect(() => {
    if (text && currentIndex < text.length) {
      const timer = setTimeout(() => {
        setDisplayedText((prev) => prev + text.charAt(currentIndex));
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }, speed);
      return () => clearTimeout(timer);
    }
  }, [currentIndex, text, speed]);

  // Effect to reset the animation when the text prop changes
  useEffect(() => {
    setDisplayedText("");
    setCurrentIndex(0);
  }, [text]);

  // Determine if the cursor should be shown
  const showCursor = currentIndex < (text?.length || 0);

  return (
    <VuiTypography component="span" variant="body1" color={color} sx={sx}>
        {displayedText}
      {showCursor && <Cursor />}
    </VuiTypography>
  );
};

export default TypingText; 